import { JsonApiSort } from './json-api-sort';

export function serializeSort(sort: ReadonlyArray<JsonApiSort>) {
  return sort.map((s) => (s.desc ? `-${s.property}` : s.property)).join(',');
}
